import ShortCutKey from '../../interaction/shortcutkey/index';
import Textarea from '../../interaction/textarea';

function init() {
    ShortCutKey.on({
        keyName: 'ctrl+i',
        callback: (event) => {
            Textarea.create();
        }
    });

    ShortCutKey.on({
        keyName: 'command+i',
        callback: (event) => {
            Textarea.create();
        }
    });
}

export default {
    init
};
